import { assertUnreachable } from '@shared/helpers/function.helpers';
import type { BlueprintInteractionMode } from '../blueprint-underlay/blueprint-underlay-controller';

/**
 * True when the map vertex Backspace/Delete handler must leave the event
 * uncancelled so the Design canvas can remove the selected PDF page.
 *
 * That map listener is registered first and used to cancel every
 * Backspace/Delete. The canvas listener runs later and bails when the event
 * is already cancelled, so swallowing the key here drops the page delete.
 * A selected shape still owns the key.
 */
export const shouldYieldDeleteToBlueprintUnderlay = (options: {
  isBlueprintUnderlaySelected: boolean;
  hasSelectedShape: boolean;
}): boolean => options.isBlueprintUnderlaySelected && !options.hasSelectedShape;

/**
 * True when Backspace/Delete should remove the selected PDF page.
 * The caller must already have ignored the key when a shape claimed it.
 */
export const shouldRemoveSelectedBlueprintUnderlay = (options: {
  mode: BlueprintInteractionMode;
  hasUnderlay: boolean;
}): boolean => {
  if (!options.hasUnderlay) return false;
  switch (options.mode) {
    case 'transform':
    case 'calibrate':
      return true;
    case 'locked':
      return false;
    default:
      return assertUnreachable(options.mode);
  }
};
